var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex items-center rounded-md border-solid border-2 h-16 bg-white px-4 py-2 text-slate-600",class:{
    'shadow border-woot-100': _vm.isFocused,
    'border-slate-50 shadow-sm': !_vm.isFocused,
  }},[_c('fluent-icon',{attrs:{"icon":"search"}}),_vm._v(" "),_c('input',{staticClass:"w-full focus:outline-none text-base h-full bg-white px-2 py-2 text-slate-700 placeholder-slate-500",attrs:{"type":"text","placeholder":_vm.searchPlaceholder,"role":"search"},domProps:{"value":_vm.value},on:{"input":_vm.onChange,"focus":_vm.onFocus,"blur":_vm.onBlur}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }